export const gridLayout = {
  md: 12,
  sm: 12
};
